// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_agentV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "HiddenPropertyPreviewAgent",
    "VisiblePropertyPreviewAgent"
  ]);
}

let fragmentConverter = {"__root":{"showings":{"f":""},"mlsPlan":{"f":""},"agentV2_VisiblePropertyPreviewAgent_agent":{"f":""},"agentV2":{"u":"fragment_agentV2"}}};

let fragmentConverterMap = {
  fragment_agentV2: unwrap_fragment_agentV2
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function forSalePropertyAgentVisibilityReason_decode($$enum) {
  if ($$enum === "OWN_ANONYMOUS" || $$enum === "VISIBLE_TO_ALL") {
    return $$enum;
  }
}

let forSalePropertyAgentVisibilityReason_fromString = forSalePropertyAgentVisibilityReason_decode;

function membershipStatusV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "TERMINATED") {
    return $$enum;
  }
}

let membershipStatusV5_fromString = membershipStatusV5_decode;

let Utils = {
  forSalePropertyAgentVisibilityReason_decode: forSalePropertyAgentVisibilityReason_decode,
  forSalePropertyAgentVisibilityReason_fromString: forSalePropertyAgentVisibilityReason_fromString,
  membershipStatusV5_decode: membershipStatusV5_decode,
  membershipStatusV5_fromString: membershipStatusV5_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardRelayPreviewSidecard_displayHelpers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShowingV5",
      "kind": "LinkedField",
      "name": "showings",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PropertyPageNextShowing_showing"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "agentV2",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "membershipStatus",
              "storageKey": null
            }
          ],
          "type": "HiddenPropertyPreviewAgent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visibilityRule",
              "storageKey": null
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": "Agent",
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ContactAgentButton_agent"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AgentInfo_agent"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "OwnAnonymousAgentInfo_agent"
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "type": "VisiblePropertyPreviewAgent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "mlsPlan",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PropertyPreviewHelpers",
  "abstractKey": null
};
})());

let wrap_fragment_agentV2 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_agentV2 = unwrap_fragment_agentV2;
exports.wrap_fragment_agentV2 = wrap_fragment_agentV2;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
